<template>
	<span>{{ `${prefix}${formattedCurrency}` }}</span>
</template>

<script>
export default {
	name: 'Currency',
	props: {
		value: {
			type: Number,
			default: 0,
		},
		code: {
			type: String,
			default: null,
		},
		prefix: {
			type: String,
			default: '',
		},
	},
	data() {
		return {};
	},
	computed: {
		isDisplayBalance() {
			return this.$store.state.accountBalance && this.$store.state.accountBalance.isDisplayBalance; // balance is not displayed for the real currency (if isDisplayBalance is false for the TW region then it's real currency for HIT2 and in this case we should display the currency itself not $t('points') )
		},
		formattedCurrency() {
			if (this.code === 'NX') {
				return `${this.$n(this.value)} ${this.code}`;
			} else if (this.code === 'TWD') {
				if (this.isDisplayBalance) return `${this.$n(this.value)} ${this.$t('points')}`;
				else return `${this.$n(this.value)} ${this.code}`; // FE-2720 display TWD instead of NT$ for the TW direct deposit (HIT2 game case)
			} else if (this.$n(this.value, 'currency', this.code)) {
				return this.$n(this.value, 'currency', this.code);
			}
			return `${this.$n(this.value)} ${this.code}`; // it shouldn't be here but just in case currency doesn't exist
		},
	},
};
</script>
